export default __webpack_public_path__ + "media/images/portfolio/portfolio-6-e9341d7a9b288adedc78e3bf0c12152d.jpg";